var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _path0, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCatProfileFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#cat-profile-filled_svg__a)"
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#C7ABDA",
  d: "M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FBA666",
  d: "M9.857 8.274C8.26 6.875 5.654 4.388 4.124 5.458s1.581 6.634 1.581 6.634c-.431 3.004-.112 4.952 2.563 6.265-.594 5.675-7.47 4.647-6.935 12.574.119.872.629 2.597 1.621 3.567.956.933 2.059 1.448 3.983 1.512 1.314.128 3.029-.011 2.422-1.032.48.002 1.004.036 1.004.036.388.818.643 1.084 1.498 1.075.884-.02 1.18-.865 1.15-1.128l.244.044s.058 1.267 1.437 1.256c.862-.083 1.066-.771 1.066-.771s1.724.57 2.77.545c1.045-.025 1.46-.44.998-1.134s-2.425-1.027-2.425-1.027c.941-1.657 4.99-5.194 2.601-7.528 1.945-4.273 1.1-8.266-.095-11.307 1.368-2.002 1.675-4.115-1.7-7.074-1.017-5.033-2.238-6.685-3.405-6.397-1.167.289-2.029 3.487-2.152 5.477-1.245.425-2.493 1.228-2.493 1.228"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M5.615 7.318c-.275.264.781 2.634 1.348 3.459.6-.481 1.44-1.341 1.44-1.341-.67-.967-2.513-2.381-2.788-2.117M14.06 7.087c.26.254 1.786.485 2.006.347-.16-1.62-.796-3.527-1.127-3.55-.466.046-.879 3.202-.879 3.202M5.1 18.153a.14.14 0 0 1-.177-.039.14.14 0 0 1 .024-.195c.029-.022 2.96-2.261 6.063-3.65.07-.03.154 0 .187.07a.14.14 0 0 1-.069.184c-3.072 1.374-5.978 3.594-6.007 3.616zM6.607 19.031a.14.14 0 0 1-.17-.03.14.14 0 0 1 .008-.196c1.81-1.635 2.867-2.4 4.934-3.732a.14.14 0 0 1 .195.04.137.137 0 0 1-.04.193c-2.053 1.323-3.102 2.082-4.898 3.705a.2.2 0 0 1-.03.02M22.914 10.595a.1.1 0 0 1-.046.014c-1.08.15-4.92.907-7.084 1.885a.143.143 0 0 1-.187-.069.137.137 0 0 1 .068-.184c2.192-.99 6.071-1.755 7.162-1.907a.14.14 0 0 1 .16.118.14.14 0 0 1-.073.142M23.14 12.727a.14.14 0 0 1-.066.016c-.845-.007-4.18.354-6.713.886a.14.14 0 0 1-.167-.107.14.14 0 0 1 .107-.164c1.49-.313 5.287-.904 6.773-.892.078 0 .14.063.14.14 0 .052-.03.098-.074.121M14.826 19.872c-.636-1.179-1.773-1.543-2.375-1.12-.601.422-1.094 1.253.004 3.124 1.098 1.87 1.687 2.984 1.845 3.434 1.934-1.91 2.903-3.188 3.312-4.508s.066-2.163-.678-2.421-1.974.867-2.108 1.491"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#19335A",
  d: "M11.7 13.288c.771-.673 2.148-1.158 2.483-1.097.082 1.04-.569 2.076-.569 2.076-.703-.135-1.61-.463-1.914-.979"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#19335A",
  d: "M13.027 13.683 14.04 15.8l.428-.198-1.014-2.118z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#19335A",
  d: "M14.566 15.77c-.866.45-1.792.305-2.391.118a.236.236 0 0 1-.158-.295.237.237 0 0 1 .298-.153c.966.3 2.297.322 3.153-1.285a.24.24 0 0 1 .422.222c-.379.712-.842 1.145-1.323 1.394M9.375 18.677c-.77-.112-1.102-.31-1.102-.31a7 7 0 0 1-.099.641c.278.028.68-.024 1.2-.33M19.939 15.802a22 22 0 0 0-.295-.793c-.299.505-.78.942-.78.942s.537.159 1.075-.149"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M15.966 8.949c-.482-.623-1.34-.766-1.919-.32-.578.446-.656 1.312-.175 1.935.481.622 1.34.765 1.918.319s.657-1.312.176-1.934"
})), /*#__PURE__*/React.createElement("mask", {
  id: "cat-profile-filled_svg__b",
  width: 4,
  height: 4,
  x: 13,
  y: 8,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M15.963 8.95c-.482-.623-1.34-.768-1.917-.323-.577.444-.653 1.31-.171 1.935.482.623 1.34.768 1.917.324.577-.445.653-1.312.171-1.935"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#cat-profile-filled_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#19335A",
  d: "M16.148 9.424c-.312-.408-.848-.373-1.198.08-.35.452-.38 1.15-.068 1.558.311.408.848.372 1.198-.08s.38-1.15.068-1.558"
}))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M10.516 11.265c-.481-.622-1.34-.765-1.918-.32-.578.447-.657 1.313-.175 1.935.48.622 1.34.765 1.918.32.578-.447.657-1.312.175-1.935"
})), /*#__PURE__*/React.createElement("mask", {
  id: "cat-profile-filled_svg__c",
  width: 3,
  height: 4,
  x: 8,
  y: 10,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M10.513 11.267c-.482-.624-1.34-.769-1.917-.324s-.654 1.311-.171 1.935c.482.624 1.34.769 1.917.324s.653-1.311.171-1.935"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#cat-profile-filled_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#19335A",
  d: "M10.698 11.74c-.312-.408-.848-.372-1.198.08s-.38 1.15-.069 1.558c.312.408.849.373 1.199-.08.35-.451.38-1.15.068-1.557"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "cat-profile-filled_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12"
})))));
export default SvgCatProfileFilled;